import React from 'react';
import Navbar from '../components/Navbar';
import SeasonalBanner from '../components/SeasonalBanner';
import Pastries from '../components/Pastries';
import SavoirFaire from '../components/SavoirFaire';
import Formats from '../components/Formats';
import Footer from '../components/Footer';
import { useLang } from '../LanguageContext';
import { ThemeProvider, useTheme } from '../ThemeContext';

const Inner = () => {
  const { t } = useLang();
  const theme = useTheme();
  return (
    <div className="min-h-screen" style={{ background: '#f6ecd9' }}>
      <SeasonalBanner />
      <Navbar />
      <section className="relative pb-20 overflow-hidden" style={{ background: theme.primary, paddingTop: 'calc(var(--banner-h, 0px) + 160px)' }}>
        <div
          className="absolute inset-0 opacity-[0.07]"
          style={{
            backgroundImage: 'radial-gradient(#d4a94c 1px, transparent 1px)',
            backgroundSize: '28px 28px'
          }}
        />
        <div className="relative max-w-6xl mx-auto px-6">
          <p className="text-[11px] tracking-[0.35em] uppercase text-[#d4a94c] mb-6 fade-up">
            {t.page.catPast}
          </p>
          <h1 className="font-serif text-5xl md:text-7xl text-[#f6ecd9] leading-[1.05] fade-up fade-up-delay-1">
            {t.page.catPastT1} <em className="italic font-light text-[#d4a94c]">{t.page.catPastT1b}</em>{t.page.catPastT2}
          </h1>
          <p className="text-[#f6ecd9]/75 text-base md:text-lg mt-8 max-w-2xl leading-relaxed fade-up fade-up-delay-2">
            {t.page.catPastDesc}
          </p>
        </div>
      </section>
      <Pastries />
      <SavoirFaire variant="pastry" />
      <Formats />
      <Footer />
    </div>
  );
};

const PastriesPage = () => (
  <ThemeProvider name="green">
    <Inner />
  </ThemeProvider>
);

export default PastriesPage;
